<script setup lang="ts">
import DefaultLayout from "@/components/layouts/DefaultLayout.vue";
import { useAuthStore } from "@/stores/auth";
import UserArea from "../../components/ui/UserArea.vue";
import BroadcastMessageTabNav from "../../components/ui/BroadcastMessageTabNav.vue";
import { useQuery, useResult } from "@vue/apollo-composable";
import { gql } from "@apollo/client/core";
import { dateRelative } from "@/libs/filters";

const authStore = useAuthStore();

const { loading, error, result } = useQuery(
  gql`
    query broadcastMessages($after: String, $first: Int) {
      broadcastMessages(after: $after, first: $first) {
        pageInfo {
          endCursor
          hasNextPage
        }
        nodes {
          title
          body
          createdAt
          sentToAll
          senderId
          id
        }
      }
    }
  `,
  {},
  {
    fetchPolicy: "network-only",
  }
);

const broadcastMessages = useResult(result, null, (data) => {
  return data.broadcastMessages;
});
</script>

<template>
  <DefaultLayout>
    <article class="container framework-slot">
      <UserArea title="Mensagens de Disparo em Massa">
        <BroadcastMessageTabNav>
          <div class="row">
            <div class="col">
              <table v-if="loading" class="table table-dark">
                <thead>
                  <tr>
                    <th scope="col">Título</th>
                    <th scope="col">Mensagem</th>
                    <th scope="col">Enviado por</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td colspan="3" align="center">Carregando...</td>
                  </tr>
                </tbody>
              </table>

              <table
                v-else-if="broadcastMessages && broadcastMessages.nodes.length"
                class="table table-dark"
              >
                <thead>
                  <tr>
                    <th scope="col">Título</th>
                    <th scope="col">Mensagem</th>
                    <th scope="col">Enviada há</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="message of broadcastMessages.nodes">
                    <th scope="col">{{ message.title }}</th>
                    <th scope="col">{{ message.body }}</th>
                    <th scope="col">{{ dateRelative(message.createdAt) }}</th>
                  </tr>
                </tbody>
              </table>

              <table v-else class="table table-dark">
                <thead>
                  <tr>
                    <th scope="col">Título</th>
                    <th scope="col">Mensagem</th>
                    <th scope="col">Enviado por</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td colspan="3" align="center">
                      Ainda não há mensagens enviadas.
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </BroadcastMessageTabNav>
      </UserArea>
    </article>
  </DefaultLayout>
</template>

<style scoped>
.table > :not(caption) > * > * {
  background-color: var(--dark-color);
}
</style>
